<template>
  <div class="contact">
    <div class="customized">
      <h1>联系我们</h1>
      <div class="heng"></div>
      <p>地址：{{info.companyAddress}}</p>
      <p>网址：<a :href="info.url" target="_blank">{{info.url}}</a></p>
      <p>电话：<a :href="`tel:${info.fixed}`">{{info.fixed}}</a>丨 <a :href="`tel:${info.phoneNumber}`">{{info.phoneNumber}}</a></p>
      <p>邮箱：<a :href="`mailto:${info.email}`">{{info.email}}</a></p>
      <div id="map" style="width: 1200px; height: 368px;margin: 20px 0 60px 0"></div>
      <!-- 需求定制 -->
      <div class="form-box">
        <h1 style="color: #fff;font-weight: 400;margin-bottom:20px "> 在线留言</h1>
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="需求定制" prop="type">
            <el-radio-group style="width: 100%;" v-model="form.type">
              <el-radio v-for="item in typeList" :key="item.id" :label="item.id">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="联系人" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入您的姓名" />
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入您的电话" />
          </el-form-item>
          <el-form-item label="联系邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入您的邮箱" />
          </el-form-item>
          <el-form-item label="留言" prop="guestbook">
            <el-input v-model="form.guestbook" type="textarea" :rows="3" show-word-limit maxlength="200" placeholder="请输入详细留言内容，我们会尽快与您联系~" />
          </el-form-item>
          <el-button class="btn-class" @click="submitForm"  style="float: right;margin-top: 20px;" type="primary">提交发送</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {configList, guestbook} from "@/utils/http";
import AMapLoader from '@amap/amap-jsapi-loader';
export default {
  name: "contact",
  components: {
  },
  data() {
    return {

      info: {},
      map: null,
      typeList: [
        {name: '硬件定制', id: '1'},
        {name: '软件定制', id: '2'},
        {name: '其他咨询', id: '3'},
      ],
      form: {
        type: '1',
        contact: '',
        phone: '',
        email: '',
        guestbook: '',
      },
      // 表单校验
      rules: {
        type: [
          {required: true, message: "请选择需求定制", trigger: "blur"},
          { validator: this.validateNoSpace, trigger: 'blur' }
        ],
        contact: [
          { required: true, message: "联系人不能为空", trigger: "blur" },
          { min: 1, max:10,message: '请输入10个以内字符', trigger: 'blur' },
          { validator: this.validateNoSpace, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: "联系电话不能为空", trigger: "blur" },
          { pattern: /^(0\d{2,3}-)?\d{7,8}(-\d{1,4})?$|^1[3-9]\d{9}$/, message: '请输入正确的电话，电话请加上区号与-' },
          { validator: this.validateNoSpace, trigger: 'blur' }
        ],
        email: [
          { max: 50, message: '请输入不超过50个字符', trigger: 'blur' },
          // { required: true, message: "联系邮箱不能为空", trigger: "change" },
          // { pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: '请输入正确的邮箱地址' }
        ],
        // guestbook: [
        //   { required: true, message: "留言不能为空", trigger: "change" }
        // ],

      }
    };
  },
  created() {},

  mounted() {
    this.getConfigList()
    this.$nextTick(() => {
      setTimeout(() => {
        this.getMap();
        setTimeout(() => {
          const marker = new AMap.Marker({
            map: this.map,
            position: [this.info.longitude, this.info.latitude],
          });
          marker.setMap(this.map);
        }, 500)
      }, 500)
    })
  },
  methods: {
    validateNoSpace(rule, value, callback) {
      if (/\s/.test(value)) {
        callback(new Error('此字段不能包含空格'));
      } else {
        callback();
      }
    },
    async getConfigList() {
      const res = await configList();
      this.info = res.rows[0]
    },
    getMap() {
      let that = this;
      AMapLoader.load({
        key: window.config.AMapKey, // 高德地图API Key
        version: '2.0',
        plugins: ['AMap.PlaceSearch', 'AMap.Geocoder', 'AMap.AutoComplete'],
      }).then((AMap) => {

        this.map = new AMap.Map('map', {
          zoom: 18,
          center: [this.info.longitude, this.info.latitude], // 初始化地图中心点
        });
        this.geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: 'all',
        });
        // var polygon = new AMap.Polygon({
        //   map: this.map,
        //   fillOpacity:0.4,
        //   path: this.path
        // });
        const autoOptions = {
          input: "tipinput"
        };
        const auto = new AMap.AutoComplete(autoOptions);
        const placeSearch = new AMap.PlaceSearch({
          map: this.map,
        });
        auto.on("select", select);//注册监听，当选中某条记录时会触发
        function select(e) {
          placeSearch.setCity(e.poi.adcode);
          placeSearch.search(e.poi.name);  //关键字查询查询
        }

        // 监听地图点击事件，实现选点
        this.map.on('click', (e) => {
          const lnglat = e.lnglat;
          this.map.clearMap(); // 清除之前的标记
          const marker = new AMap.Marker({
            map: this.map,
            position: lnglat,
          });
          marker.setMap(this.map);
          that.form.longitude = lnglat.getLng();
          that.form.latitude = lnglat.getLat();
          this.geocoder.getAddress([lnglat.getLng(), lnglat.getLat()], (status, result) => {
            if (status === 'complete' && result.info === 'OK') {
              that.form.address = result.regeocode.formattedAddress
              that.$forceUpdate();
            }
          });
        });
      }).catch((e) => {
        console.error(e);
      });
    },
    /**  重置  */
    reset() {
      this.form = {
        type: '1',
        contact: '',
        phone: '',
        email: '',
        guestbook: '',
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          guestbook(this.form).then(response => {
            console.log(response)
            if (response.code === 200) {
              this.$message.success("提交成功！感谢您的信任，我们将尽快与您联系，为您服务。");
              this.reset()
            } else {
              this.$message.error(response.msg)
            }
          });
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.contact {
  .customized {
    width: 1200px;
    margin: 0 auto;
    font-family: Microsoft YaHei, Microsoft YaHei;
    margin-top: 40px;
    position: relative;

    h1 {
      font-weight: bold;
      font-size: 20px;
      color: #222222;
    }

    .heng {
      width: 41px;
      height: 5px;
      background: #1277E4;
      margin: 10px 0 20px 0;
    }

    p, a {
      font-size: 14px;
      color: #222222;
      line-height: 28px;
      text-decoration: none;
    }

    .form-box {
      width: 336px;
      background: #1A2838;
      position: absolute;
      top: 0;
      right: 0;
      padding: 32px;

      .btn-class {
        padding: 0;
        width: 80px;
        height: 32px;
        background: #1262FD;
        border-radius: 2px 2px 2px 2px;
        border: none;
        font-size: 12px;
        color: #FFFFFF;
      }

      ::v-deep .el-form-item__label {
        color: #fff;
      }

      ::v-deep .el-form-item__content {
        line-height: 20px;
      }

      ::v-deep .el-input__inner {
        width: 100%;
        height: 32px;
        border: 1px solid #45515E;
        background: #1A2838;
        color: #fff;
      }

      ::v-deep .el-textarea__inner {
        border: 1px solid #45515E;
        background: #1A2838;
        color: #fff;
      }

      ::v-deep .el-textarea .el-input__count {
        background: transparent;
        color: #aaa;
      }

      ::v-deep .el-form-item {
        margin-bottom: 10px;
      }

      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        border-color: #1262FD;
        background: #1262FD;
      }

      ::v-deep .el-radio__inner {
        border-color: #1262FD;
        background: transparent;
      }

      ::v-deep .el-radio__label {
        color: rgba(255, 255, 255, 0.85);
      }

      //
      // ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
      //  content: '';
      //  width: 6px;
      //  height: 4px;
      //  border: 2px solid white;
      //  border-top: transparent;
      //  border-right: transparent;
      //  text-align: center;
      //  display: block;
      //  position: absolute;
      //  top: 3px;
      //  left: 2px;
      //  vertical-align: middle;
      //  transform: rotate(-45deg);
      //  background: none;
      //}
    }
  }

}


</style>
